import { ref, computed } from 'vue'
import { defineStore } from 'pinia'
import type { User } from '@/types/User'

export const useUserStore = defineStore(
  'user',
  () => {
    const originalUser = ref<User | null>(null)
    const isAuthenticated = computed(() => !!originalUser.value)

    const impersonatedUser = ref<User | null>(null)
    const isImpersonationMode = computed(() => !!impersonatedUser.value)

    const user = computed(() => impersonatedUser.value || originalUser.value)

    const setUser = (data: User) => {
      originalUser.value = data

      // for tests
      // originalUser.value.blocked = true
    }

    const clearUser = () => {
      originalUser.value = null
    }

    const setImpersonatedUser = (data: User | null) => {
      impersonatedUser.value = data
    }

    return {
      isAuthenticated,
      user,
      originalUser,
      setUser,
      clearUser,
      isImpersonationMode,
      impersonatedUser,
      setImpersonatedUser,
    }
  },
  {
    persist: true,
  },
)
